import { apiSlice } from 'api/apiSlice'
import { IProductSizeOption } from 'shared/types/IProductSizeOption'

type GetConditionalProductsParams = {
  slug: string
  countryCode: string
  size: number
}

const productsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getConditionalProducts: build.query<IProductSizeOption[], GetConditionalProductsParams>({
      query: ({ slug, countryCode, size }) => ({
        app: 'flightclub',
        method: 'GET',
        params: {
          slug,
          countryCode,
          size,
        },
        url: '/api/conditional-products',
      }),
    }),
  }),
})

export const { useGetConditionalProductsQuery } = productsApi
